import {
  BottomNavigationAction,
  BottomNavigation as MuiBottomNavigation,
  Paper,
} from "@mui/material";
import { ReactElement, useContext } from "react";
import { translateField } from "@cdv/jazz-i18n";
import HomeIcon from "@mui/icons-material/Home";
import HeadsetIcon from "@mui/icons-material/Headset";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import Person2Icon from "@mui/icons-material/Person2";
import { useNavigate } from "react-router";
import { ActionType, AppContext } from "@cdv/jazz-ui";
import { Resource } from "../utils";
import SettingsIcon from "@mui/icons-material/Settings";

export default function BottomNavigation(): ReactElement {
  const navigate = useNavigate();
  const { getUrl } = useContext(AppContext);

  return (
    <Paper sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 9999 }} elevation={3}>
      <MuiBottomNavigation showLabels>
        <BottomNavigationAction
          onClick={() => navigate(getUrl(Resource.Page, ActionType.INDEX))}
          label={translateField(Resource.Homepage, "education")}
          icon={<HomeIcon />}
        />
        <BottomNavigationAction
          onClick={() => navigate(getUrl(Resource.Audio, ActionType.INDEX))}
          label={translateField(Resource.Homepage, "audio")}
          icon={<HeadsetIcon />}
        />
        <BottomNavigationAction
          onClick={() => navigate(getUrl(Resource.Game, ActionType.INDEX))}
          label={translateField(Resource.Game, "title")}
          icon={<SportsEsportsIcon />}
        />
        <BottomNavigationAction
          onClick={() => navigate(getUrl(Resource.Info, ActionType.INDEX))}
          label={translateField(Resource.Info, "info")}
          icon={<SettingsIcon />}
        />
      </MuiBottomNavigation>
    </Paper>
  );
}
